import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <div className="h-16 md:h-[72px]" />

      <main className="flex-1 flex items-center justify-center px-4 py-24">
        <div className="relative text-center max-w-lg w-full">
          <h1 className="font-heading font-black text-[7rem] md:text-[10rem] leading-none text-background-200 select-none">
            404
          </h1>
          <div className="relative -mt-10">
            <span className="w-16 h-16 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center mx-auto mb-4">
              <i className="ri-compass-3-line text-3xl"></i>
            </span>
            <p className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
              页面走丢了
            </p>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
              你访问的页面不存在或已被移除，路径：
              <span className="font-mono text-foreground-700 break-all"> {location.pathname}</span>
            </p>
            <div className="flex items-center justify-center flex-wrap gap-3 mt-8">
              <Link
                to="/"
                className="px-5 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-home-4-line mr-1.5"></i> 返回首页
              </Link>
              <Link
                to="/category"
                className="px-5 py-2.5 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-200 transition-colors whitespace-nowrap"
              >
                浏览影视分类
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}